import { Pipe, PipeTransform } from '@angular/core';
import { NotificationEventType } from 'src/app/admin/logged-time/notification-management/enums/notification-event-type.enum';
import { NotificationHistoryEntry } from 'src/app/admin/logged-time/notification-management/models/notification-history-entry';

@Pipe({
  name: 'notificationEventDetails',
  pure: true,
})
export class NotificationEventDetailsPipe implements PipeTransform {
  transform(entry: NotificationHistoryEntry): string {
    if (entry.eventType !== NotificationEventType.NOTIFICATION_DATES_AUTO_SETUP) {
      return entry.eventDetails;
    }
    return entry.eventDetails.replace(/ · /g, '\n');
  }
}
